import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    rupiah = (num) => {
        let res = "-";
        if (num != null && num != ''){
            res = parseFloat(num).toLocaleString('id-ID', {maximumFractionDigits:2})
        }
        return res;
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="skillcertification"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Uang Makan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Uang Makan
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nip
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Unit Kerja 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Jabatan 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Golongan Ruang 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.rank_group_room !== "" ? this.state.detail.rank_group_room : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th colspan ="2">Nilai Tunjangan</th>
                                            </tr>
                                            <tr>
                                                <th>Nama</th>
                                                <th>Jumlah</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th>Total Tunjangan</th>
                                                <th>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_bruto) !== "" ? this.rupiah(this.state.detail.allowance_bruto) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>
                                                - &nbsp; Tidak Masuk
                                                </td>
                                                <td>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_not_present) !== "" ? this.rupiah(this.state.detail.allowance_not_present) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    - &nbsp; Telat Masuk
                                                </td>
                                                <td>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_value_late) !== "" ? this.rupiah(this.state.detail.allowance_value_late) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                - &nbsp; Pulang Cepat
                                                </td>
                                                <td>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_value_early) !== "" ? this.rupiah(this.state.detail.allowance_value_early) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                - &nbsp; Satu Kali Absen
                                                </td>
                                                <td>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_single_finger) !== "" ? this.rupiah(this.state.detail.allowance_single_finger) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Total Potongan</th>
                                                <th>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_tax) !== "" ? this.rupiah(this.state.detail.allowance_tax) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>Jumlah Bersih</th>
                                                <th>
                                                {
                                                    this.state.detail ?
                                                        <>{this.rupiah(this.state.detail.allowance_netto) !== "" ? this.rupiah(this.state.detail.allowance_netto) : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                                </th>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                            Total
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.rupiah(this.state.detail.allowance_bruto) !== "" ? this.rupiah(this.state.detail.allowance_bruto) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Pajak
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.rupiah(this.state.detail.allowance_tax) !== "" ? this.rupiah(this.state.detail.allowance_tax) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Subtotal
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.rupiah(this.state.detail.allowance_netto) !== "" ? this.rupiah(this.state.detail.allowance_netto) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/uangmakan.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);